import { Button, CheckIcon, createTheme, Modal } from "@mantine/core";
import buttonClasses from "./Button.module.scss";

const defaultTheme = createTheme({
  breakpoints: {
    xs: "300px",
  },
  components: {
    Modal: Modal.extend({
      defaultProps: {
        xOffset: -20,
        padding: 15,
        size: "80%",
        centered: true,
      }
    }),
    Button: Button.extend({
      classNames: buttonClasses,
    }),
  }
});

export default defaultTheme